// Booking ladder slot configuration — amounts per booking milestone.
// This should eventually come from a backend config API.
// quarterTarget = total slots (boss tier booking number)
export const bookingsLadder = {
  quarterTarget: 6,
  slots: [
    { label: "B1", amount: 7500  },
    { label: "B2", amount: 7500  },
    { label: "B3", amount: 7500  },
    { label: "B4", amount: 15000 },
    { label: "B5", amount: 15000 },
    { label: "B6", amount: 25000 },
  ],
};
